// extracted by mini-css-extract-plugin
module.exports = {"CovidAdMain":"CovidAd_CovidAdMain__MknDP","CovidAd":"CovidAd_CovidAd__9yn8a"};